import { useEffect } from 'react';

interface TextFXProps {
  className?: string;
  children: string;
  baseDelay?: number;
  letterDelay?: number;
}

const TextFX = ({ className = '', children, baseDelay = 300, letterDelay = 10 }: TextFXProps) => {
  useEffect(() => {
    const processTextFX = (element: HTMLElement) => {
      let html = '';
      let totalDelay = 0;
      const words = element.textContent?.split(/\s/) || [];

      words.forEach((word) => {
        html += '<span class="word">';
        
        for (let i = 0; i < word.length; i++) {
          const delay = baseDelay + letterDelay * totalDelay;
          html += `<span class="letter" style="transition-delay:${delay}ms;">${word[i]}</span>`;
          totalDelay++;
        }

        html += '</span>';
        html += `<span class="letter" style="transition-delay:${baseDelay}ms;">&nbsp;</span>`;
        totalDelay++;
      });

      element.innerHTML = html;
    };

    const elements = document.querySelectorAll('.txt-fx');
    elements.forEach((el) => processTextFX(el as HTMLElement));
  }, [children, baseDelay, letterDelay]);

  return (
    <div className={`txt-fx ${className}`}>
      {children}
    </div>
  );
};

export default TextFX;